<template>
    <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Commissies</h3>
        </div>
        <div class="block-content p-0">
          <table class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>Verkoopkanaal</th>
                <th>Commisiepercentage</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sales_channel_commission in sales_channel_commissions" :key="sales_channel_commission.id">
                <td>
                  <a>{{sales_channel_commission.sales_channel_name}}</a>
                </td>
                <td>
                  <div class="row">
                    <input v-model="commission_percentages[sales_channel_commission.id]" type="number" ref="input" class="form-control" style="width: 100px;">
                    <button type="submit" class="btn btn-success btn-noborder"  @click="updateSalesChannelCommissionField(sales_channel_commission.id)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>
<script>
import http from '../utils/http'

export default {
  data () {
    return {
      sales_channel_commissions: null,
      commission_percentages: []
    }
  },
  methods: {
    loadData () {
      this.$api.getSalesChannelCommissions()
        .then((result) => {
          this.sales_channel_commissions = result.data
          this.fillArrays()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning')
        })
    },
    updateSalesChannelCommissionField (id) {
      const data = {
        'commission_percentage': this.commission_percentages[id]
      }

      http.patch(`/sales-channels-commission/${id}`, data)
        .then((result) => {
          this.$swal('Hoera 😊', `De commissie is succesvol bijgewerkt.`, 'success')
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het bijwerken van deze commissie. Probeer het opnieuw.', 'warning')
        })
    },
    fillArrays () {
      this.sales_channel_commissions.forEach(element => {
        this.commission_percentages[element.id] = element.commission_percentage
      })
    }
  },
  created () {
    this.loadData()
  }
}
</script>


// WEBPACK FOOTER //
// CommissionTab.vue?03c5b4a2